import axios from 'axios';

export const GET_GENERAL_NOTE_STATUS_TYPES = '/generalData/getGeneralNoteStatusTypes';
export const GET_USERS_ACTIONS_OPTIONS = '/generalData/getActionLogDDOptions';
export const GET_CONTACT_STATUS_TYPES = '/generalData/getContactStatusTypes';
export const GET_TEXT_SUGGESTIONS = '/generalData/getTextSuggestions';

export const getGeneralNoteStatusTypes = async () => {
  const response = await axios.get(GET_GENERAL_NOTE_STATUS_TYPES);
  const {errorCode, body} = response.data;
  if (errorCode < 0) {
    throw new Error();
  } else {
    return body?.generalNoteStatusTypes ? body.generalNoteStatusTypes : [];
  }
};

export const getUsersActionsOptions = async () => {
  const response = await axios.get(GET_USERS_ACTIONS_OPTIONS);
  const {errorCode, body} = response.data;
  if (errorCode < 0) {
    throw new Error();
  } else {
    return body;
  }
};

export const getContactStatusTypes = async () => {
  const response = await axios.get(GET_CONTACT_STATUS_TYPES);
  const {errorCode, body} = response.data;
  if (errorCode < 0) {
    throw new Error();
  } else {
    return body?.contactStatusTypes ? body.contactStatusTypes : [];
  }
};

export const getTextSuggestions = async () => {
  const response = await axios.get(GET_TEXT_SUGGESTIONS);
  const {errorCode, body} = response.data;
  if (errorCode < 0) {
    throw new Error();
  } else {
    return body?.textSuggestions ? body.textSuggestions : [];
  }
};